<template>
    <div class="form">
        <div class="form__header">
            <a href="/"><img src="/img/logo.png" alt="HealthNow"></a>
            <p class="form__title">Healthcare reimagined</p>
        </div>
        <div class="form__body">
            <div class="typeform-widget" data-url="https://form.typeform.com/to/FUOjlCxx" data-transparency="30" data-hide-headers=true data-hide-footer=true style="width: 100%; height: 500px;"></div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'Form',
};
</script>
